import { HttpInterceptorFn } from '@angular/common/http';
import { environment } from '../../../environments/environment';

export const authInterceptor: HttpInterceptorFn = (req, next) => {

  // if the token has been stored in sessionStorage...
  // const token = sessionStorage.getItem('access_token');
  const token = 'eyJ0eXAiOiJKV1QiLCJlbmMiOiJBMTI4Q0JDLUhTMjU2IiwiYWxnIjoiZGlyIn0..OjZEi-tbyYHGhL7oIlo4gA.b-rOSimU4ACYl3I27toX-cW98C8Yzr-8sCD1SvSxwrM-PzqSgpsvSZOWfLbnzI2coGZYXPxNhwSQal0O5VZh3_E1f60ca8vZkdkcTr4jdwdqxFQ3HNOKm3SCLeXI6Rwy1Wf7BGwalhCEdGTweRLO2SmDCN1gaLRrcW8WaIMvHPRiVmMIOpdvVKyMeUP3vrxx1ThMgcq8zofWIUDhwLpcaL3ihU4Z6CS08Nn5AA6NxxhHAxe0HBmN_RtfjuU3febF6CYpsHJgKOO_s2G1eSQ-MEH5MjFTjDI11vhtRN16d1x_kyGvA8zj8sB7inzgkvizlEZGcOuMu-oXYZFnjzzmarNhNKx4oiFWM1m67VF0KN9dAQdc52N0RSoabRSZ8sveLH706GSW2UtV8V9EMRYXazkDIK9Pi6Zr6-JAUmX6y5EtqhFGFBa5mNP1xFQ6XN36jHY46DbBD-_oL534SMlobISQhk-SMv9NDlhq810k1iQx1fdpBjkbp8bXtSdaxT3knXiV9pVTBaKUOL202W0OGMk9IuKrcV64A6DJplpeBuNYMVXJ-SoH6agNgGCvlMY6Ds2AOsTxAIte4fkJKH6fyfS3zEjukgkPr8T5goLYkJ1f5ZAHD8m0aLkvg_YtionPUj8M3gS74bKz3f0SLYL446sVmWS2HI-QX5mlhbipCzlDFUVDrSWqb4zJljwegoXKSqh86JJRxY90o36PdECqD3UulXo_hDGfHMw5hUeZseQLgyKiL1KDUkmkvx4kdb23nrKOfL7TfO12FhKhQf0VrPSrlKGYS6VcIIQopgIvLX-zWo6ob3LgDzWwzlVwPRWmL59hkLpvKvXtTABPrEqLaqIJtu0rMDwLdGu7uS0YzXDbTQS419C62i3WC67wdO7Cf58Fzv15ANhtBjM79ZvoQa15jShZOsmpFVyNsGMvcUn0fYa6R6vMVx8TsuNXG_hRjWl9HvIl557Pr9Uv4NsbWTfLHvltIsmMvWt66AucrCYcG-DBj6pI49ZpAfzxTod8B9VbuQmagVZRfVLD-MSQKI3-yHeQsA5t9F_wgKQupUdV8HRMKOo6mM5BpNeZDKQjpZDGoxbMowYG2y5rroZmG6HiuZRkj1LyANDPnw7vicc.CPx1Tf2TGQ3reQiN1JtVEg';
  

  /**
   * A list of domains to set custom headers and Bearer token, the list must be exclude all domains related to ping identity.
   * If you need to set a custo domain please add into the environment file. 
   */
  const allowedDomains = [environment.apiURL];

  // If the domain exist int the list will add the custom headers
  const isIntheList = allowedDomains.some(domain => req.url.startsWith(domain));

  // const ssoToken = 'haJef6DTMWoVrH8M0w3pcowSVEI.*AAJTSQACMDIAAlNLABxaZHk3L3lQSVAvVXg3K2NZTVo0eVJGRzJONUk9AAR0eXBlAANDVFMAAlMxAAIwMQ..*';

  let headersConfig: Record<string, string> = {
    Authorization: `Bearer ${token}`,
    'x-auth-vendor': 'forgeRock',
    // 'cookie-set': ssoToken
  }

  // If we want to validate the SSO Token we will include the cookie
  // const callingToVerifySSOToken = req.url.includes('/profile/validate');
  // if(callingToVerifySSOToken) {
  //   headersConfig['a1d213d00e6ea91'] = ssoToken;
  // }

  // Update password flow
  const initialStepFlow = req.url.includes('/profile/update-password') || req.url.includes('/profile/mfa-registration');

  if(initialStepFlow) {
    const url = new URL(req.url, window.location.origin);
    const queryParams = new URLSearchParams(url.search);
    const initialStep = queryParams.get('flow')
    if(initialStep === 'init') {
      headersConfig['X-OpenAM-Username'] = 'demouser12@yopmail.com';
    }
  }

  if (isIntheList) {
    if (token) {
      const cloned = req.clone({
        setHeaders: headersConfig
      });
      return next(cloned);
    }    
  }
  return next(req);
};
